import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { server_API } from "../config";
import arrow from "../images/Stroke 1.svg";
import Select from "react-select";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector } from "react-redux";
import { selectCid } from "../features/companyid";
import { selectUuid } from "../features/userid";
import { TailSpin } from "react-loader-spinner";
import { ToastIcon } from "./TestOfferInitiation";
import { getPhoneCode } from "../utils/currencyUtils";
function BulkUpload() {
  const location = useLocation();
  const originalCsvData = location?.state?.data;
  const jobId = location?.state?.jobid;
  const [csvData, setCsvData] = useState(location?.state?.data);
  const filename = location?.state?.Name;
  const obj = csvData[0];
  const [loader, setLoader] = useState(false);
  const [success, setSuccess] = useState(false);
  // const companyId = localStorage.getItem('cid')
  const companyId = useSelector(selectCid);
  const applicantId = useSelector(selectUuid);
  // State to hold original keys
  const [originalKeys, _] = useState(
    Object?.keys(obj)?.map((key) => key.replace(/\r/g, ""))
  );
  const [companyCountryCode, setCompanyCountryCode] = useState("IN");

  const lowerOrginalKeys = originalKeys?.map((str) => str.toLowerCase());
  useEffect(() => {
    errorHandling();
    if (companyId) {
      axios
        .get(`${server_API}/v2/company/get/${companyId}`)
        .then((response) => {
             if (response.data.company_countries && response.data.company_countries.length > 0) {
               setCompanyCountryCode(response.data.company_countries[0]);
             }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [companyId]);
  const errorHandling = () => {
    if (
      !lowerOrginalKeys?.includes("name") ||
      !lowerOrginalKeys?.includes("phone") ||
      !lowerOrginalKeys.includes("email")
    ) {
      toast.error("Please upload the csv in correct format", {
        position: "top-right",
        className: "bg-green-500 text-white",
      });
    }
  };

  // State to hold current keys after swapping
  const [keys, setKeys] = useState(originalKeys);

  const handleSwap = (index1, swapKey2) => {
    const keyIndex1 = index1;
    const keyIndex2 = keys.indexOf(swapKey2);

    if (keyIndex1 === -1 || keyIndex2 === -1) {
      alert("One or both keys are invalid.");
      return;
    }

    const updatedKeys = [...keys];
    [updatedKeys[keyIndex1], updatedKeys[keyIndex2]] = [
      updatedKeys[keyIndex2],
      updatedKeys[keyIndex1],
    ];

    setKeys(updatedKeys);
  };

  const keyCount = keys.length;
  const options = originalKeys.map((key) => {
    const label = key?.replace(/"/g, "");
    const value = key?.replace(/"/g, "");
    return { label, value };
  });

  //use arrow function as it gives cleaner code
  function handleConfirm(csvData, originalKeys, updatedKeys) {
    setLoader(true);
    // Map over each row in the CSV data
    const updatedCsvData = csvData.map((row) => {
      const updatedRow = {};
      // Map over the original keys
      originalKeys?.forEach((originalKey, index) => {
        // Replace the original key with the corresponding updated key
        updatedRow[updatedKeys[index]] = row[originalKey];
      });
      return updatedRow;
    });
    console.log(updatedCsvData);
    setCsvData(updatedCsvData);
    sendMail();
  }
  const sendMail = () => {
    axios
      .post(`${server_API}/v2/applicant/sendbulk`, {
        JobID: jobId,
        CompanyID: companyId,
        ApplicantDetails: csvData,
        UserID: applicantId,
        countrycode: getPhoneCode(companyCountryCode),
      })
      .then((response) => {
        if (response.status == 200) {
          toast.success("Successfully upload",{icon:<ToastIcon/>});
          setLoader(false);
          setSuccess(true);
        }

        console.log(response);
      })
      .catch((error) => {
        toast.error("Headers are not in correct format");
        setLoader(false);
        console.log(error);
      });
  };

  function handleCancel() {
    setCsvData(originalCsvData);
    setKeys(originalKeys);
  }

  return (
    <>
      <div>
        <div className="bg-[#f0f4fc] min-h-screen">
          <div className="pb-24">
            <div className="px-6 py-8">
              {success ? (
                <span className="text-3xl font-medium">Upload Completed</span>
              ) : (
                <span className="text-3xl font-medium">
                  Bulk Upload in Progress...
                </span>
              )}
            </div>
            <div className="px-6">
              <div className="bg-white  rounded-lg  shadow-xl">
                <div className="card-header flex justify-between py-6 px-3">
                  <div className="flex flex-col justify-start px-3">
                    <span className="text-lg font-medium">
                      “{filename}” has {keyCount} columns
                    </span>
                    <span className="text-base font-normal">
                      Map column to attribute for successful upload
                    </span>
                  </div>
                </div>
                <div className="border w-full"></div>

                <div className="card-body p-6 grid grid-cols-3 gap-7">
                  {keys.map((columns, index) => (
                    <div className="bg-white border-solid border border-[#8F94A1] rounded-md  ">
                      <div className="card-header flex justify-between pt-5 px-6 pb-3">
                        <div className="flex flex-row justify-start gap-1">
                          <span className="text-lg font-medium">
                            Column {index + 1}:
                          </span>
                          <span className="text-lg font-medium">{columns}</span>
                        </div>
                      </div>
                      <div className="border w-full"></div>

                      <div className="card-body p-6 flex flex-col gap-3">
                        <div className="select flex flex-col gap-1  pb-3">
                          <span className="text-base font-medium">Map to</span>
                          <div className="flex relative">
                            {/* <select
                          className="appearance-none block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:border-blue-500"
                          onChange={(e) => {
                            handleSwap(index, e.target.value);
                          }}
                        >
                          {options.map((option, index) => (
                            <option
                              key={index}
                              value={option.value}
                              selected={option.label === columns}
                            >
                              {option.label}
                            </option>
                          ))}
                        </select> */}
                            <Select
                              className="block w-full"
                              options={options}
                              onChange={(selectedOption) => {
                                handleSwap(index, selectedOption.value);
                              }}
                              value={options.find(
                                (option) => option.label === columns
                              )}
                            />
                          </div>
                        </div>

                        <div className="display flex flex-col gap-1 px-2 pt-1">
                          {originalCsvData.length > 3 ? (
                            <>
                              <span className="text-[#444D63]">
                                {originalCsvData[0][
                                  originalKeys[index]
                                ]?.toString()}
                              </span>
                              <span className="text-[#444D63]">
                                {originalCsvData[1][
                                  originalKeys[index]
                                ]?.toString()}
                              </span>
                              <span className="text-[#444D63]">
                                {originalCsvData[2][
                                  originalKeys[index]
                                ]?.toString()}
                              </span>
                              <span className="text-[#444D63]">
                                <span className="text-[#444D63]">.......+</span>
                                <span className="text-[#444D63]">
                                  {originalCsvData.length - 3}
                                </span>
                              </span>
                            </>
                          ) : (
                            originalCsvData.map((rowData, rowIndex) => (
                              <span key={rowIndex} className="text-[#444D63]">
                                {rowData[originalKeys[index]]?.toString()}
                              </span>
                            ))
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="border w-full"></div>
                <div className=" card-footer pb-6 pl-6 pr-6 pt-3 relative">
                  <div className="flex justify-end gap-4">
                    <button
                      className="border-solid border-2 border-[#F7284A] text-[#F7284A] py-2 px-8 rounded"
                      onClick={() => handleCancel()}
                    >
                      Cancel
                    </button>

                    <button
                      className="bg-[#148EFF] hover:bg-blue-700 text-white  py-2 px-8 rounded"
                      onClick={() => handleConfirm(csvData, originalKeys, keys)}
                    >
                      {loader ? (
                        <TailSpin
                          color="white"
                          height="30"
                          width="30"
                        ></TailSpin>
                      ) : (
                        "Confirm Attributes"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer
        autoClose={5000}
        hideProgressBar={true}
        toastClassName={(context) =>
          " relative flex p-1  min-h-10 rounded-[8px] bg-white w-fit flex-row justify-between border-2 border-[#0DCD94] overflow-hidden cursor-pointer"
        }
        bodyClassName={() =>
          "text-[14px] gap-3 flex text-[#161A21] font-medium  p-3  pr-1"
        }
      />
    </>
  );
}

export default BulkUpload;
